import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/prob.css';
import Slide from 'react-reveal/Slide';
import Fade from 'react-reveal/Fade';
import { Helmet } from 'react-helmet';

const probStyle = {
    fontSize: 55,
}

const Problem = () => {
    return (
        <div className="Problem">
            <Helmet>
                <title>{"PASADA | Problems"}</title>
                <meta name="description" content="PASADA PH Web Application" />
            </Helmet>
            <div className="containerproblem"></div>
            <div className="problemarti d-flex justify-content-center align-items-center p-5 mt-5">
                <Fade big>
                    <div className="w-75 m-5 border-bottom">
                        <h1 class="text-center" style={probStyle}>PROBLEMS</h1>
                    </div>
                </Fade>
            </div>
            <div className="container">
                <div className="row gx-3 my-0 mb-5">
                    <Slide bottom>
                        <div className="col-sm-6 col-md-4">
                            <div className="card border-0">
                                <img src={require('./images/probimg/accident1.jpg')} alt="Images"
                                    className="card-img-top rounded w-100" />
                                <div className="card-body">
                                    <h5 className="card-title">3,233 Bus Accidents in 2019</h5>
                                    <p className="card-text">MMDA’s Metro Manila Accident Reporting and Analysis
                                        System</p>
                                </div>
                            </div>
                        </div>
                    </Slide>

                    <Slide bottom>
                        <div className="col-sm-6 col-md-4">
                            <div className="card border-0">
                                <img src={require('./images/probimg/accident.jpg')} alt="Images"
                                    class="card-img-top rounded w-100 h-75" />
                                <div className="card-body">
                                    <h5 className="card-title">2,562 Public Jeepney Accidents in 2019</h5>
                                    <p className="card-text">MMDA’s Metro Manila Accident Reporting and Analysis
                                        System</p>
                                </div>
                            </div>
                        </div>
                    </Slide>

                    <Slide bottom>
                        <div className="col-sm-6 col-md-4">
                            <div className="card border-0">
                                <img src={require('./images/probimg/humanfactor.jpg')} alt="Images"
                                    className="card-img-top rounded" />
                                <div className="card-body">
                                    <h5 className="card-title">"Human Factor" is Leading Cause of Accidents</h5>
                                    <p className="card-text">PNP-HPG</p>
                                </div>
                            </div>
                        </div>
                    </Slide>
                </div>
            </div>
        </div>
    );
}

export default Problem;